import React from "react";
import { useTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { getVideoList } from "../../services/ContentServices";
import {
  Box,
  Drawer,
  InputAdornment,
  TablePagination,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { AddTrendingVideo } from "../../services/ContentManagementService";
import { Video } from "../content/types";
import { TableBodyVideoList } from "../../utils/ContentCardList";
import { useSnackbar } from "notistack";

interface DrawerTrendingVideoManagementProps {
  open: boolean;
  onClose: () => void;
  position: 0 | 1 | 2 | 3;
  onUpdate: () => void;
}
const DrawerTrendingVideoManagement: React.FC<
  DrawerTrendingVideoManagementProps
> = ({ open, onClose, position, onUpdate }) => {
  const theme = useTheme();

  return (
    <>
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        sx={{
          "& .MuiDrawer-paper": {
            backgroundColor: theme.palette.background.paper,
            borderTopLeftRadius: theme.spacing(2),
            borderBottomLeftRadius: theme.spacing(2),
            width: "30%",
            height: "100vh",
            boxSizing: "border-box",
          },
        }}
      >
        <Box
          component="form"
          aria-label="Video List"
          sx={{
            display: "flex",
            backgroundColor: theme.palette.background.paper,
            flexDirection: "column",
            height: "100vh",
            maxHeight: "100vh",
            boxSizing: "border-box",
          }}
        >
          <VideoList position={position} reload={onUpdate} onClose={onClose} />
        </Box>
      </Drawer>
    </>
  );
};

export default DrawerTrendingVideoManagement;

export const VideoList = ({
  position,
  reload,
  onClose,
}: {
  position: 0 | 1 | 2 | 3;
  reload: () => void;
  onClose: () => void;
}) => {
  const theme = useTheme();
  const [loading, setLoading] = useState<boolean>(false);
  const [totalElements, setTotalElements] = useState<number>(0);

  const rowsPerPageOptions = [5, 15, 25];
  const [rowsPerPage, setRowsPerPage] = useState<number>(rowsPerPageOptions[0]);

  const [page, setPage] = useState<number>(0);
  const [videos, setVideos] = useState<Video[]>([]);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    getVideos();
  }, [page, rowsPerPage]);

  const getVideos = async () => {
    setLoading(true);
    try {
      const response = await getVideoList({ page, size: rowsPerPage });
      setVideos(response.data.content);
      setTotalElements(response.data.totalElements);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleAddTrendingVideo = async (id: string): Promise<number> => {
    const status = await AddTrendingVideo({ videoId: id, position });
    if (status == 200) {
      enqueueSnackbar("Successfully ! Video has been Added", {
        variant: "success",
      });
      await reload();
      onClose();
      return 200;
    } else {
      enqueueSnackbar("Failed!! Video has not Added", {
        variant: "error",
      });
      return 401;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: theme.palette.background.paper,
        flexDirection: "column",
        height: "100vh",
        minHeight: "100vh",
        maxHeight: "100vh",
        padding: theme.spacing(1),
        boxSizing: "border-box",
      }}
    >
      <Box
        mb={2}
        mt={2}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <TextField
          placeholder="Search by name"
          variant="outlined"
          size="small"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          marginBottom: theme.spacing(1),
          scrollbarWidth: "none",
        }}
      >
        <TableBodyVideoList
          drawer
          loading={loading}
          videos={videos}
          callBackchange={handleAddTrendingVideo}
          //   disableChange={selectedPlayList}
          //   refreshList={onDataUpdate}
          //   storedVidIds={storedVidIds}
        />
      </Box>
      <Box sx={{ marginTop: "auto" }}>
        <TablePagination
          rowsPerPageOptions={rowsPerPageOptions}
          component="div"
          count={totalElements}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
    </Box>
  );
};
